import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IServicio } from 'src/app/models/monitoreo-servicios/monitoreo-servicios.model';

@Component({
  selector: 'app-service-detail-dialog',
  templateUrl: './service-detail-dialog.component.html',
  styleUrls: ['./service-detail-dialog.component.scss']
})
export class ServiceDetailDialogComponent {
    public readonly STATUSES = {
        DISPONIBLE: 'Disponible',
        INTERMITENTE: 'Intermitente',
        FUERA_SERVICIO: 'Fuera de Servicio',
    }

    constructor(@Inject(MAT_DIALOG_DATA) public servicio: IServicio) {}

    getChipColorClass(status: string): string {
		switch (status) {
			case this.STATUSES.DISPONIBLE:
				return 'available-chip';
			case this.STATUSES.INTERMITENTE:
				return 'warning-chip';
			case this.STATUSES.FUERA_SERVICIO:
				return 'error-chip';
			default:
				return '';
		}
	}

	getStatusIcon(status: string): string {
		switch (status) {
			case this.STATUSES.DISPONIBLE:
				return 'check_circle';
			case this.STATUSES.INTERMITENTE:
				return 'error';
			case this.STATUSES.FUERA_SERVICIO:
				return 'cancel';
			default:
				return '';
		}
	}
}
